import type { ReactNode } from 'react';
import { PageHeader } from '@lognai/synapse-design-system-v2';
import { useDatasetRefresh } from './dataset-refresh';

export function AnalyticsHeader({
  title,
  subtitle,
  actions,
  meta,
}: {
  title: string;
  subtitle: string;
  onNavigate?: (path: string) => void;
  defaultDashboardId?: string;
  actions?: ReactNode;
  meta?: ReactNode;
}) {
  useDatasetRefresh();
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={
          meta || actions ? (
            <>
              {meta}
              {actions}
            </>
          ) : undefined
        }
      />
    </div>
  );
}
